<mat-toolbar color="primary">
    <mat-toolbar-row>
        <button #navigationToggle data-onboarding="navigation.toggle" mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle navigation">
            <mat-icon>menu</mat-icon>
        </button>

        <a class="logo-link" routerLink="/app" aria-label="Go to dashboard">
            <img class="fire-survey-pro-logo hide-on-mobile" src="assets\images\logo\FSP_Orange_BG.png" alt="Fire Survey Pro Logo" />
        </a>

        <span class="flex-spacer"></span>

        @if (usesCredits && authService.credits < (authService.getTenantSetting('low_credit_warning')?.payload ?? 400) && authService.credits >= 0) {
            <button
                    class="pill d-none d-md-inline"
                    mat-raised-button
                    (click)="purchaseCredits()"
                    style="margin-right: 10px; background-color: #ffee58 !important; color: black;"
            >
                <mat-icon style="margin-right: 5px; line-height: 23px; font-size: 20px;">warning</mat-icon>
                Low Credits
            </button>
        }

        @if (usesCredits) {
        <button mat-raised-button (click)="viewBilling()" color="accent" tourAnchor="dashboard.credits" style="margin-right: 10px;" aria-label="View plan and billing">
            <mat-icon style="margin-right: 5px; vertical-align: middle;">toll</mat-icon>
            <span style="vertical-align: middle;">{{ authService.credits | number:'' }}</span>
        </button>
        }

        <!-- <button ngIf="usersService?.user?.tenants.length > 1; else singleTenant" mat-button class="float-end" [matMenuTriggerFor]="tenantMenu">
            <mat-icon>arrow_drop_down</mat-icon>
            {{ authService.tenant.name }}
        </button>

        <mat-menu #tenantMenu="matMenu" ngIf="usersService?.user?.tenants.length > 1">
            <button *ngFor="let tenant of usersService.user.tenants" mat-menu-item (click)="switchTenant(tenant)">
                <span>{{ tenant.name }}</span>
            </button>
        </mat-menu> -->

        @if (showDeveloperMenu) {
            <button class="hide-on-mobile" mat-icon-button [matMenuTriggerFor]="developerMenu">
                <mat-icon>terminal</mat-icon>
            </button>

            <mat-menu #developerMenu="matMenu">
                <button mat-menu-item [matMenuTriggerFor]="testPlanMenu" [disabled]="impersonationService.isImpersonating || switchingTestPlan">
                    <mat-icon>science</mat-icon>
                    Switch test plan ({{ effectivePlan || 'real plan' }})
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="openImpersonateDialog()">
                    <mat-icon>manage_search</mat-icon>
                    Impersonate User
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="resetTours()">
                    <mat-icon>tour</mat-icon>
                    Reset Tours
                </button>
                <button mat-menu-item (click)="throwTestError()">
                    <mat-icon>bug_report</mat-icon>
                    Test Sentry Error
                </button>
            </mat-menu>
        }

        <mat-menu #testPlanMenu="matMenu">
            @for (plan of testPlans; track plan.value) {
                <button mat-menu-item (click)="switchTestPlan(plan.value)" [disabled]="switchingTestPlan">{{ plan.label }}</button>
            }
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="switchTestPlan(null)" [disabled]="switchingTestPlan">Restore real plan</button>
        </mat-menu>

        <button class="hide-on-mobile" mat-icon-button [matMenuTriggerFor]="helpMenu" tourAnchor="dashboard.help" aria-label="Help Centre">
            <mat-icon>help</mat-icon>
        </button>

        <mat-menu #helpMenu="matMenu" class="help-menu">
            @if (walkthroughService.canReplayPage) {
                <button mat-menu-item (click)="replayPageGuide()" [disabled]="walkthroughService.starting"><mat-icon>replay</mat-icon><span>Replay this page’s guide</span></button>
                <mat-divider></mat-divider>
            }
            @if (onboardingGuide.available) {
                <button mat-menu-item (click)="openOnboardingGuide()"><mat-icon>checklist</mat-icon><span>Get started</span></button>
                <mat-divider></mat-divider>
            }
            <mat-action-list>
                <mat-list-item (click)="openExternalLink('help')">
                    <mat-icon matListItemIcon>import_contacts</mat-icon>
                    <span matListItemTitle>Help Guide</span>
                    <span matListItemLine>Click here to view support documentation for the Fire Survey Pro app.</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('ticket')">
                    <mat-icon matListItemIcon>support</mat-icon>
                    <span matListItemTitle>Having Issues?</span>
                    <span matListItemLine>Click here to raise a support ticket.</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('email')">
                    <mat-icon matListItemIcon>email</mat-icon>
                    <span matListItemTitle>Email Us</span>
                    <span matListItemLine>support&#64;firesurveypro.co.uk</span>
                </mat-list-item>

                <mat-list-item (click)="openExternalLink('phone')">
                    <mat-icon matListItemIcon>phone</mat-icon>
                    <span matListItemTitle>Call Us</span>
                    <span matListItemLine>01482 425516</span>
                </mat-list-item>
            </mat-action-list>
        </mat-menu>

        <button mat-button class="float-end" [matMenuTriggerFor]="userMenu" tourAnchor="dashboard.user-menu">
            <mat-icon class="me-2" style="font-size: 24px; width: 24px; height: 24px; line-height: 24px; vertical-align: middle;">account_circle</mat-icon>
            <div style="display: inline-block;">
                <span style="display: block; line-height: normal;">{{ authService.tenant.name }}</span> <span style="display: block; float: left; line-height: normal; font-weight: lighter;">{{ usersService.user.name }}</span>
            </div>
        </button>

        <mat-menu #userMenu="matMenu">
            <button mat-menu-item (click)="toggleTheme()">
                <mat-icon>{{ currentTheme === 'light-theme' ? 'dark_mode' : 'light_mode' }}</mat-icon>
                <span>{{ currentTheme === 'light-theme' ? 'Dark Mode' : 'Light Mode' }}</span>
            </button>

            <mat-divider></mat-divider>

            <button mat-menu-item (click)="openUserPreferences()">
                <mat-icon>manage_accounts</mat-icon>
                <span>User Settings</span>
            </button>

            <mat-divider></mat-divider>

            <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Sign Out</span>
            </button>
        </mat-menu>
    </mat-toolbar-row>
</mat-toolbar>
@if (activeTestPlan || switchingTestPlan) {
    <div class="test-plan-banner" role="status">
        <strong>{{ switchingTestPlan ? 'Switching test plan…' : 'Test plan: ' + activeTestPlan }}</strong>
        <span>Access preview for this tab. Billing is unchanged. Refreshing or signing out clears it.</span>
        <button mat-button (click)="switchTestPlan(null)" [disabled]="switchingTestPlan">Restore real plan</button>
    </div>
}


@if (impersonationService.isImpersonating) {
    <div class="impersonation-banner">
        <span class="impersonation-message">
            <mat-icon>info</mat-icon>
            Acting as {{ impersonationService.impersonatedUserName || usersService.user?.name }}
            @if (impersonationService.impersonatedUserEmail) {
                ({{ impersonationService.impersonatedUserEmail }})
            }
        </span>
        <button mat-button class="stop-impersonation-button" (click)="stopImpersonating()">
            Stop Impersonating
        </button>
    </div>
}

<mat-sidenav-container [class.with-impersonation-banner]="impersonationService.isImpersonating">
    <!-- TODO: Need to confirm the behaviour of the opened expression -->
    <mat-sidenav class="side-bar-expanded" [mode]="(themeService.handset | async) ? 'side' : 'push'" [opened]="!!(themeService.handset | async)" tourAnchor="dashboard.navigation" #sidenav>
        <ng-scrollbar class="sidenav-scrollbar scrollbar" visibility="hover">
            <mat-nav-list aria-label="Main navigation">
                @for (group of visibleNavigationGroups; track group.key) {
                    @if (group.key === 'work') {
                        <div mat-subheader>{{ group.label }}</div>
                        <ng-container [ngTemplateOutlet]="navigationLinks" [ngTemplateOutletContext]="{links: group.links}"></ng-container>
                    } @else {
                        <details class="navigation-group" [open]="expandedNavigation[group.key]" (toggle)="setNavigationExpanded(group.key, $event)">
                            <summary class="navigation-group__heading" [class.navigation-group__heading--active]="isNavigationGroupActive(group)">
                                <span>{{ group.label }}</span>
                                <mat-icon aria-hidden="true">expand_more</mat-icon>
                            </summary>
                            <ng-container [ngTemplateOutlet]="navigationLinks" [ngTemplateOutletContext]="{links: group.links}"></ng-container>
                        </details>
                    }
                }
            </mat-nav-list>

            <ng-template #navigationLinks let-links="links">
                @for (link of links; track link.url) {
                    <a mat-list-item [attr.data-onboarding]="link.url === 'app/sites' ? 'navigation.sites' : link.url === 'app/reports' ? 'navigation.reports' : null" routerLink="/{{ link.url }}" (click)="closeMobileNavigation()" [class.active]="isNavigationLinkActive(link)" [activated]="isNavigationLinkActive(link)">
                        <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
                        <span matListItemTitle class="nav-title-row">
                            <span>{{ link.name }}</span>
                            @if (link.badge !== undefined) { <span class="nav-count" [attr.aria-label]="link.badge + ' items overdue or due in the next 30 days'">{{ link.badge }}</span> }
                        </span>
                    </a>
                }
            </ng-template>

            <mat-action-list>
                <mat-divider></mat-divider>
                <div mat-subheader>Support</div>

                @if (usesCredits) {
                <button mat-list-item (click)="purchaseCredits()">
                    <mat-icon matListItemIcon>toll</mat-icon>
                    <span matListItemTitle>Buy Credits</span>
                    <span matListItemLine>{{ authService.credits }}</span>
                </button>
                }

                <button mat-list-item [matMenuTriggerFor]="helpMenu">
                    <mat-icon matListItemIcon>help</mat-icon>
                    <span matListItemTitle>Help Centre</span>
                </button>

                <mat-divider></mat-divider>
            </mat-action-list>

            @if (canUseMobileApp) {
            <div class="app-store-icons mt-2" tourAnchor="dashboard.mobile">
                <a href="https://apps.apple.com/us/app/fire-survey-pro/id6479811537" target="_blank">
                    <img ngSrc="../../../assets/images/apple_appstore_icon.svg" alt="Apple App Store Icon" height="40" width="120" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=surveyorpro.firesurveypro" target="_blank">
                    <img ngSrc="../../../assets/images/android_appstore_icon.png" alt="Android App Store Icon" class="m-1" height="80" width="270" />
                </a>
            </div>
            }
        </ng-scrollbar>
    </mat-sidenav>

    <mat-sidenav-content>
        <ng-scrollbar class="admin-scrollbar scrollbar" visibility="hover">
            <div class="admin-content-shell" [class.with-onboarding-guide]="onboardingGuide.visible">
                <router-outlet></router-outlet>
            </div>
        </ng-scrollbar>
        <app-admin-footer></app-admin-footer>
    </mat-sidenav-content>
</mat-sidenav-container>

<app-onboarding-guide #onboardingGuide [obscured]="onboardingNavigation.active || (sidenav.opened && sidenav.mode === 'push')" (navigationRequested)="showTaskNavigation($event)" (opened)="onOnboardingOpened()" (dismissed)="navigationToggle.focus()"></app-onboarding-guide>

<app-onboarding-navigation (recalled)="openOnboardingGuide()"></app-onboarding-navigation>

<div class="centered-tour-element" tourAnchor="dashboard.welcome"></div>
